// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"401":"1420c8487bc3b88c3b49","556":"b711e4c10a73c3b9e435","599":"2ee024a48b17ba7a45cb"}[chunkId] + ".css";
};